import { useAppSelector } from '@brands/hooks/useReduxHook';
import { UserRoleName } from '@brands/services/identity/types/UserProfile';
import { selectAuth } from '@brands/store/selectors/auth';
import { AuthState } from '@brands/store/slices/authSlice';
import React from 'react';

import NotFoundPage from '../NotFoundPage/NotFoundPage';
import CaseChatWindowPatient from './CaseChatWindowPatient';

// Every role shares one Messages screen: the staff-specific page stopped matching the
// design and staff were moved onto this one on purpose. The component varies its own
// copy by role, so the switch below only decides who may see the screen at all.
const CaseChatWindow: React.FC = () => {
  let component: JSX.Element;
  const user: AuthState = useAppSelector(selectAuth);

  switch (user.userInfo?.role.name) {
    case UserRoleName.CareAdvisor:
    case UserRoleName.OrganizationAdmin:
    case UserRoleName.Admin:
    case UserRoleName.SuperAdmin:
    case UserRoleName.Patient:
    case UserRoleName.Provider:
    case UserRoleName.Collector:
      component = <CaseChatWindowPatient />;
      break;

    default:
      component = <NotFoundPage />;
      break;
  }

  return <div>{component}</div>;
};

export default CaseChatWindow;
